import React from 'react';
import { BsCodeSlash } from '@react-icons/all-files/bs/BsCodeSlash';

import { decorateComponent } from '../../documentComponents';
import { getDisallowedAncestors } from '../../utils';
import { HTMLTemplate } from './HTMLTemplate';
import { HTMLTemplateInspector } from './HTMLTemplate.Inspector';

export default decorateComponent(HTMLTemplate, 'block', {
  id: 'html-template',
  label: 'HTML 템플릿',
  defaultProps: {},
  allowedChildren: [],
  disallowedAncestors: getDisallowedAncestors(['grid']),
  renderIcon: () => <BsCodeSlash />,
  renderInspector: HTMLTemplateInspector,
});
